import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import ModalBody from '../../atoms/ModalBody';
import ModalFotterYesNoButtonComponent from '../../molecules/ModalFotterYesNoButtonComponent';

class DeleteConfirmModal extends React.Component {
  static get propTypes() {
    return {
      targetId: PropTypes.string,
      children: PropTypes.string,
      show: PropTypes.bool,
      onYesClick: PropTypes.func,
      onNoClick: PropTypes.func,
    };
  }

  render() {
    return (
      <Modal show={this.props.show}>
        <ModalBody>
          <p className="text-center">
            選択されたロールを削除してよろしいですか？
          </p>
        </ModalBody>
        <ModalFotterYesNoButtonComponent
          onNoClick={this.props.onNoClick}
          onYesClick={this.props.onYesClick}
        />
      </Modal>
    );
  }
}

export default DeleteConfirmModal;
